
import { Component, Mixins } from 'vue-property-decorator'
import HeaderRoundedCtrl from '~/components/common/header/HeaderRoundedCtrl.vue'
import ApplyPro from '~/components/common/freemium/ApplyPro.vue'
import StreakEventBar from '~/components/gamification/StreakEventBar.vue'
import UserInformPanel from '~/components/common/header/UserInformPanel.vue'
import UserDropDown from '~/components/common/header/UserDropDown.vue'
import Logo from '~/components/common/header/Logo.vue'
import ButtonFS from '~/components/common/buttons/ButtonFS.vue'
import ButtonReactivate from '~/components/common/buttons/ButtonReactivate.vue'
import DropDown from '~/components/common/header/DropDown.vue'
import ApplyReactivate from '~/components/common/maintenance/ApplyReactivate.vue'
import Icon from '~/components/common/icon/Icon.vue'
import DashboardButton from '~/components/common/buttons/DashboardButton.vue'
import WinnersBtnFeature from '~/components/features/WinnersBtn'

@Component({
  components: {
    ApplyReactivate,
    HeaderRoundedCtrl,
    ApplyPro,
    StreakEventBar,
    UserInformPanel,
    UserDropDown,
    Logo,
    ButtonReactivate,
    ButtonFS,
    DropDown,
    Icon,
    DashboardButton
  }
})
export default class Header extends Mixins(WinnersBtnFeature) {
  private GAME_MVP = 'GameMVP'

  private toggleSideBar() {
    this.$accessor.sideBar.toggleSideBar()
  }

  private streakCtrlHandler() {
    this.$mixpanel.track(this.$mixpanel.events.NEW_STREAKS_ICON_CLICK)

    this.changeSeenStatus()
  }

  private changeSeenStatus() {
    if (this.$accessor.gameStreak.streak && !this.$accessor.gameStreak.streak.statusSeen) {
      this.$accessor.gameStreak.updateStreak({ statusSeen: 1 })
        .then(() => this.$accessor.gameStreak.getStreaks())
        .catch(err => this.$sentry.captureException(err))
    }
  }

  get isPro() {
    return !!this.$auth.user.membership && !this.$auth.user.membership?.freemium && !this.$auth.user.membership?.isMaintenanceModeHasEffect
  }

  get isMyAccount() {
    return this.$route.fullPath.includes('my-account')
  }

  get isMailbox() {
    return this.$route.fullPath.includes('mailbox')
  }

  get freeTrialEndDate() {
    return !!this.$auth.user.membership && this.$auth.user.membership?.freeTrial && this.$auth.user.membership?.freeTrialEndDate
      ? this.$auth.user.membership?.freeTrialEndDate
      : null
  }

  get activeUntil() {
    return !!this.$auth.user.membership && this.$auth.user.membership?.activeUntil && !this.$auth.user.membership?.freeTrial
      ? this.$auth.user.membership?.activeUntil
      : null
  }

  get packageName() {
    if (!this.$auth.user.membership) { return '' }
    return this.$auth.user.membership?.id
      ? this.$auth.user.membership?.name
      : 'free'
  }

  get isMob() {
    return this.$accessor.screen.resolution < 768
  }

  get packageType() {
    if (!this.$auth.user.membership) { return '' }
    if (this.$auth.user.membership?.freeTrial) { return 'Free trial' }
  }

  get date() {
    if (!this.endDate) { return '' }
    const date = new Date(this.endDate)
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
  }

  get endDate() {
    return this.freeTrialEndDate || this.activeUntil
  }

  get isScholarshipsPage() {
    return this.$route && this.$route.fullPath && this.$route.fullPath.includes('/scholarships')
  }

  get isUnlockProInHeaderVisible() {
    return !this.isPro &&
      !this.$auth.user.membership?.isMaintenanceModeHasEffect &&
      !this.isMyAccount &&
      this.$route.path.includes('scholarships')
  }
}

